/* Tredjeparts-scripts indlæses først, når de skal bruges, og aldrig i <head>.
 *
 * Årsagen er målt: prerenderingen af siden venter på, at netværket falder til ro.
 * Google Analytics, PostHog og Trustpilots to scripts lå synkront i <head> og gjorde
 * en kold crawl af /business-undersiderne 3 til 5 sekunder lang, hvilket fik eksterne
 * crawlere til at timeoute. Ingen af dem gør noget, før brugeren har givet samtykke,
 * og en crawler giver aldrig samtykke, så den får nu slet ikke scriptene.
 */

const cache = new Map();

const loadScript = (src) => {
  if (cache.has(src)) return cache.get(src);
  const p = new Promise((resolve, reject) => {
    const el = document.createElement("script");
    el.src = src;
    el.async = true;
    el.onload = () => resolve();
    el.onerror = () => reject(new Error(`kunne ikke indlæse ${src}`));
    document.head.appendChild(el);
  });
  cache.set(src, p);
  return p;
};

/** Venter til browseren er ledig, så scriptene ikke konkurrerer med sidens eget indhold. */
const whenIdle = (fn) => {
  if (typeof window.requestIdleCallback === "function") {
    window.requestIdleCallback(fn, { timeout: 3000 });
  } else {
    setTimeout(fn, 1500);
  }
};

const GA_ID = "G-LF2CS4J5NK";
const POSTHOG_KEY = "phc_xAvL2Iq4tFmANRE7kzbKwaSqp1HJjN7x48s3vr0CMjs";
const POSTHOG_HOST = "https://us.i.posthog.com";
const POSTHOG_ASSETS = "https://us-assets.i.posthog.com/static/array.js";

const loadPosthog = () =>
  loadScript(POSTHOG_ASSETS).then(() => {
    const ph = window.posthog;
    if (!ph || ph.__votraInit) return;
    ph.init(POSTHOG_KEY, {
      api_host: POSTHOG_HOST,
      person_profiles: "identified_only",
      session_recording: { recordCrossOriginIframes: true, capturePerformance: false },
    });
    ph.__votraInit = true;
  });

/** GA4 og PostHog. Kaldes kun når brugeren har sagt ja til statistik.
 *  `dataLayer` og `gtag()` findes allerede fra index.html, så alt der er lagt i køen
 *  (consent-default, config) afspilles automatisk, når gtag.js lander. */
export const loadAnalytics = () => {
  whenIdle(() => {
    loadScript(`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`).catch(() => {});
    loadPosthog().catch(() => {});
  });
};

/** Trustpilots TrustBox-widget. Kaldes af den komponent, der faktisk viser en TrustBox. */
export const loadTrustpilotWidget = () =>
  loadScript("https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js");

/** Trustpilots invitationsservice. Kaldes først lige før en invitation skal sendes. */
export const loadTrustpilotInvite = () => {
  if (!window.tp) {
    window.TrustpilotObject = "tp";
    window.tp = function tp() {
      (window.tp.q = window.tp.q || []).push(arguments);
    };
  }
  if (!window.tp.__votraRegistered) {
    window.tp("register", "IbcifgOeoJf5Ro51");
    window.tp.__votraRegistered = true;
  }
  return loadScript("https://invitejs.trustpilot.com/tp.min.js");
};
